import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_AdvDirectivesChild = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_AdvDirectivesChild' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><h4>Health Care Surrogate</h4></p>
                <p className='w-750'>I understand that I have the right to name a health care surrogate in the event I am determined to be incapacitated
                    to make decisions for my child/ward regarding mental health or medical treatment. I understand that a healthcare
                    surrogate designee is allowed to make healthcare decisions for my child/ward, can provide, withhold, or withdraw
                    consent on behalf of my child/ward, can apply for public benefits for my child/ward to defray the cost of health
                    care, and can authorize my child's/ward's admission to or transfer from a medical or mental health treatment
                    facility, I also understand thta making a designation of a healthcare surrogate is not a condition for treatment in
                    or admission to a medical or mental health facility for my child/ward.</p>
                <p className='w-750'><h4>Uniform Organ Donation</h4></p>
                <p className='w-750'>I understand that I have the right to make designations regarding the donation of my child/ward's body or body parts
                    for the purposes of transplantation, therapy, medical research, or education. I understand that I can make this
                    designation for my child/ward via this form or on my child's/ward's Florida drivers license (if appplicable) or my
                    child's/ward's Florida identification card (if applicable). I further understand that making a designation
                    regarding the donation of my child's/ward's body or body parts is not a condition for treatment in or admission to
                    a medical or mental health facility for my child/ward.</p>
                <p className='w-750'><h4>Living Will</h4></p>
                <p className='w-750'>I understand that I have the right to create a living will, which will allow me to make designations regarding
                    healthcare surrogacy, uniform organ donation, and more for my child/ward.</p>
                <p className='w-750'>By signing below, I acknowledge that I have received and understand my child's/ward's advance directive rights as
                    stated above.</p>

                
            </div>
        </form>

    )
}











